import React, { useState, useEffect } from 'react';
import { Paper, TextField, Grid, Typography, InputAdornment, CircularProgress, MenuItem, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Pagination } from '@mui/material';
import { Col, Row } from 'react-bootstrap';
import './certificates.css'
import ApiService from "../../functions/apiService";
import CalendarLoader from '../../components/Calendar/CalendarLoader';
import SearchIcon from "@mui/icons-material/Search";
import AddCerificate from './AddCertificate';
import Modal from 'react-bootstrap/Modal';
import ViewCertificate from './ViewCertificate';
import moment from 'moment';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { Link, useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import CustomSelect from '../../components/Schedule/CustomSelect';

const AllCertificates = () => {
    const [certificatesData, setCertificatedData] = useState([])
    const [certificateDropdown, setCertificateDropdown] = useState([])
    const [positionDropdown, setPositionDropdown] = useState([])
    const [loading, setLoading] = useState(false);
    const [addModal, setAddModal] = useState(false);
    const [deletModal, setDeleteModal] = useState(false)
    const [deleteId, setDeleteId] = useState('')
    const [viewModal, setViewModal] = useState(false)
    const [viewId, setViewId] = useState('')
    const [certificationStatus, setCertificationStatus] = useState('');
    const [certificationList, setCertificationList] = useState('');
    const [positionFilter, setPositionFilter] = useState('');
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResult, setSearchResult] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const itemsPerPage = 10;
    const statusDropdown = [
        { value: "valid", label: "Valid" },
        { value: "expiring", label: "Expiring" },
        { value: "expired", label: "Expired" }
    ]

    const getCertificates = (showLoader = false, showLoader2 = false) => {
        if (showLoader) {
            setLoading(true);
        }
        const payload = {
            search: searchResult,
            filter: certificationStatus,
            position: positionFilter,
            Certificate_id: certificationList,
            limit: itemsPerPage,
            page: currentPage,
        };
        ApiService.post(`/all-certificate-employees`, payload)
            .then(({ data }) => {
                setCertificatedData(data?.data || []);
                setTotalPages(Math.ceil(data.total / itemsPerPage));
                setLoading(false);
            })
            .catch(() => {
                setLoading(false);
            })
    }

    useEffect(() => {
        const showLoader = !searchResult;
        const showLoader2 = !currentPage;
        getCertificates(showLoader, showLoader2);
    }, [currentPage, searchResult, certificationStatus, certificationList, positionFilter])


    const certificateDropdownData = () => {
        setLoading(true);
        ApiService.get('/get-certificates-dropdown')
            .then(({ data }) => {
                var certArr = data?.data.map((cer) => { return { label: cer.Name, value: cer.Certificate_id } })
                setCertificateDropdown(certArr || [])
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            })
    }

    const positionDropdownData = () => {
        setLoading(true);
        ApiService.get('/positions-list')
            .then(({ data }) => {
                var certArr = data?.data.map((cer) => { return { label: cer.SO_Desc, value: cer.SO_Value } })
                setPositionDropdown(certArr || [])
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
            })
    }

    useEffect(() => {
        certificateDropdownData()
        positionDropdownData()
    }, [])

    const deleteCertificate = () => {
        setLoading(true);
        ApiService.get('/delete-certificate/' + deleteId)
            .then(({ data }) => {
                setDeleteId('')
                setDeleteModal(false)
                toast.success(data.message)
                getCertificates()
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err?.response?.data?.message)
            })
    }

    const DaysToExpiration = (expirationDate) => {
        const today = moment();
        const expiry = moment(expirationDate);
        const difference = expiry.diff(today, 'days');
        return difference;
    };

    const ExpiryValue = (expirationDate) => {
        if (!expirationDate) {
            return 'Valid';
        }
        const daysLeft = DaysToExpiration(expirationDate);
        if (daysLeft > 10) {
            return 'Valid';
        } else if (daysLeft >= 0 && daysLeft <= 10) {
            return 'Expiring';
        } else {
            return 'Expired';
        }
    };

    const handlePageChange = (_, value) => {
        setCurrentPage(value);
    };

    const resetFilters = () => {
        setSearchResult('')
        setCertificationStatus('')
        setPositionFilter('')
        setCertificationList('')
        setCurrentPage(1)
    }


    return (
        <>

            <Paper className="p-4" style={{ marginTop: "1rem" }}>
                <Row>
                    <Grid container spacing={2} alignItems="center" justifyContent="space-between">
                        <Grid item xs={9}>
                            <Typography variant="h5">
                                <Link to="/firehouse/certificates/" style={{ color: "black", zIndex: 2, position: 'relative' }}>
                                    <ArrowBackIosIcon />
                                </Link>
                                Certifications
                            </Typography>
                        </Grid>
                    </Grid>
                </Row>
                <Row>
                    <Grid container spacing={2} >
                        <Grid item xs={12} md={2.5} className='mt-2'>
                            <TextField
                                className='mt-1 w-100' color='secondary' variant="outlined"
                                select size='small'
                                label="Certification Status"
                                placeholder='Certification Status'
                                value={certificationStatus}
                                onChange={(e) => {
                                    setCertificationStatus(e.target.value);
                                }}
                                InputProps={{
                                    sx: {
                                        height: '48px',
                                    }
                                }}
                            >
                                <MenuItem key={1} value={"valid"}>Valid </MenuItem>
                                <MenuItem key={2} value={"expiring"}>Expiring </MenuItem>
                                <MenuItem key={3} value={"expired"}>Expired </MenuItem>

                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={2.5} className='mt-2'>
                            <TextField
                                className='mt-1 w-100' color='secondary' variant="outlined"
                                select size='small'
                                label="Certification List"
                                placeholder='Certification List'
                                value={certificationList}
                                onChange={(e) => {
                                    setCurrentPage(1)
                                    setCertificationList(e.target.value);
                                }}
                                InputProps={{
                                    sx: {
                                        height: '48px',
                                    }
                                }}
                            >
                                {certificateDropdown.map((certificate, index) => (
                                    <MenuItem key={index} value={certificate.value}>{certificate?.label} </MenuItem>
                                ))}

                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={2.5} className='mt-2'>
                            <TextField
                                className='mt-1 w-100' color='secondary' variant="outlined"
                                select size='small'
                                label="Positions"
                                placeholder='Positions'
                                value={positionFilter}
                                onChange={(e) => {
                                    setPositionFilter(e.target.value);
                                }}
                                InputProps={{
                                    sx: {
                                        height: '48px',
                                    }
                                }}
                            >
                                {positionDropdown.map((position, index) => (
                                    <MenuItem key={index} value={position.value}>{position.label} </MenuItem>
                                ))}

                            </TextField>
                        </Grid>
                        <Grid item xs={12} md={2.5} className='mt-2'>
                            <TextField
                                id="outlined-basic"
                                label=""
                                placeholder='Search'
                                variant="outlined"
                                value={searchResult}
                                onChange={(e) => setSearchResult(e.target.value)}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon />
                                        </InputAdornment>
                                    ),
                                }}
                                sx={{
                                    '& .MuiOutlinedInput-root': {
                                        height: 48,
                                        marginTop: '4px'
                                    },
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} md={2} className='mt-2'>
                            <ButtonTheme type='submit' variant="filled" color='primary' className='mt-2'
                                onClick={resetFilters}>
                                Reset Filters
                            </ButtonTheme>
                        </Grid>
                    </Grid>
                </Row>
                {loading ?
                    (
                        <div className="w-100 h-100 d-flex justify-content-center align-items-center mt-4">
                            <CircularProgress />
                        </div>
                    ) : (
                        <Grid className='mt-4'>
                            <TableContainer>
                                <Table sx={{ maxWidth: "90vw", overflow: "scroll" }} aria-label="simple table">
                                    <TableHead sx={{ backgroundColor: "#F9FAFB", borderBottom: "1px solid #E5E9EB" }} >
                                        <TableRow>
                                            <TableCell >Certificate Name</TableCell>
                                            <TableCell >Member Name</TableCell>
                                            <TableCell >Position Name</TableCell>
                                            <TableCell >Status</TableCell>
                                            <TableCell >Expiring Date</TableCell>
                                            <TableCell >Actions</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {certificatesData && certificatesData.length > 0 ? certificatesData.map((list, index) => (
                                            <TableRow key={index} >
                                                <TableCell className='py-2' >{list.certificate.Name}</TableCell>
                                                <TableCell className='py-2'>{`${list?.employee?.employee_assignment?.EA_Rank || ''} ${list?.employee?.First_name || ''} ${list?.employee?.Middle_Name || ''} ${list?.employee?.Last_name || ''}`}</TableCell>
                                                <TableCell className="py-2">
                                                    {list.positions?.map((pos) => pos.Position).join(', ')}
                                                </TableCell>

                                                <TableCell className='py-2'>
                                                    <span className={`certificate-status ${ExpiryValue(list.Expiration_Date)}`}>
                                                        {ExpiryValue(list.Expiration_Date)}
                                                    </span>
                                                </TableCell>
                                                <TableCell className='py-2' >
                                                    {list.Expiration_Date ? moment(list.Expiration_Date).format('MM/DD/YY') : '-'}
                                                </TableCell>
                                                <TableCell className='py-2'>
                                                    <div style={{display:'flex'}}>
                                                        <Col md='auto' className=''>
                                                            <img src='/images/edit.svg' style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setAddModal(true)
                                                                    setViewId(list.Certificate_id)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col md='auto'>
                                                            <img src='/images/eye.svg' style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setViewId(list.Certificate_id)
                                                                    setViewModal(true)
                                                                }}
                                                            />
                                                        </Col>
                                                        <Col md='auto'>
                                                            <img src='/images/delete.svg' style={{ cursor: 'pointer' }}
                                                                onClick={() => {
                                                                    setDeleteModal(true)
                                                                    setDeleteId(list.Certificate_id)
                                                                }}
                                                            />
                                                        </Col>
                                                    </div>
                                                </TableCell>
                                            </TableRow>
                                        ))
                                            :
                                            <TableRow>
                                                <TableCell colSpan={6} style={{ textAlign: 'center' }}>
                                                    No results
                                                </TableCell>
                                            </TableRow>
                                        }
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Pagination
                                count={totalPages}
                                page={currentPage}
                                onChange={handlePageChange}
                                color="primary"
                                className="mt-4 d-flex"
                                style={{ justifyContent: 'end' }}
                            />
                        </Grid>
                    )
                }
                <Modal show={deletModal} onHide={() => setDeleteModal(false)}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Certificate</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div style={{ color: '#555555' }}>
                            Are you sure to delete this Certificate?
                        </div>
                        <Row>
                            <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='white' className='mt-4' onClick={() => {
                                    setDeleteModal(false)
                                }}>
                                    Cancel
                                </ButtonTheme>
                            </Col>
                            <Col md='auto'>
                                <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={deleteCertificate}>
                                    Delete
                                </ButtonTheme>
                            </Col>
                        </Row>
                    </Modal.Body>
                </Modal>
                {addModal &&
                    <AddCerificate addModal={addModal} setAddModal={setAddModal} editId={viewId}
                        setViewId={setViewId} loadCertificates={getCertificates} />
                }
                {viewModal &&
                    <ViewCertificate id={viewId} viewModal={viewModal} setViewModal={setViewModal}
                        setViewId={setViewId} />
                }
            </Paper>
        </>
    )
}

export default AllCertificates